import { render, staticRenderFns } from "./TreasuryView.vue?vue&type=template&id=ddd8e5be&scoped=true"
import script from "./TreasuryView.vue?vue&type=script&lang=js"
export * from "./TreasuryView.vue?vue&type=script&lang=js"
import style0 from "./TreasuryView.vue?vue&type=style&index=0&id=ddd8e5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd8e5be",
  null
  
)

export default component.exports